import { fabric } from 'fabric';
import ToolOption from '../common/ToolOption';
import { CanvasEventType, GraphName, GraphType } from '../constants/Constants';
import UndoManager from '../manager/UndoManager';
import log from 'loglevel';
import Graphic from './Graphic';

/**
 * 圆
 *
 * @export
 * @class CanvasCircle
 * @extends {Graphic}
 * @author zhenliang.sun
 */
export default class CanvasCircle extends Graphic {
  constructor(app) {
    super(app);
  }

  set option(val) {
    super.option = val;
    if (!val) {
      this._option = this.defaultOption();
    }

    Object.assign(this._option, val);
  }

  get option() {
    return this._option;
  }

  get defaultOption() {
    return new ToolOption();
  }
  addEvents() {
    super.addEvents();
    let circle, isMousedown, ox, oy;

    this.root.on(CanvasEventType.MouseDown, o => {
      isMousedown = true;
      let sp = this.root.getPointer(o.e);
      ox = sp.x;
      oy = sp.y;
      sp = this.root.getPointer(o.e);
      circle = new fabric[GraphName.CIRCLE]({
        left: ox,
        top: oy,
        originX: 'left',
        originY: 'top',
        fill: 'transparent',
        stroke: this._option.stroke,
        strokeWidth: this._option.strokeWidth,
        angle: 0,
        rx: 1,
        ry: 1
      });
      circle.selectable = false;
      log.info(o, sp, circle);
      this.root.add(circle);
    });

    this.root.on(CanvasEventType.MouseMove, o => {
      if (!isMousedown) {
        return;
      }
      let pointer = this.root.getPointer(o.e);
      if (ox > pointer.x) {
        circle.set({
          left: Math.abs(pointer.x)
        });
      }
      if (oy > pointer.y) {
        circle.set({
          top: Math.abs(pointer.y)
        });
      }
      let rx = Math.abs(ox - pointer.x) / 2;
      let ry = Math.abs(oy - pointer.y) / 2;
      circle.set({
        rx: rx,
        ry: ry
      });
      this.root.renderAll();
    });

    this.root.on(CanvasEventType.MouseUp, o => {
      isMousedown = false;
      circle.setCoords();

      let data = this.factory.createAddData(circle);
      // MsgSender.add(data)
      this.app.sender.add(data);
      let allData = this.root.toDatalessJSON();
      UndoManager.getInstance().save(allData);
    });
  }

  removeEvents() {
    super.removeEvents();
    this.root.off(CanvasEventType.MouseDown);
    this.root.off(CanvasEventType.MouseMove);
    this.root.off(CanvasEventType.MouseUp);
  }

  static toAddData(target) {
    let obj = Graphic.toAddData(target);
    obj.rx = target.rx.toFixed(1);
    obj.ry = target.ry.toFixed(1);
    obj.gtype = GraphType.CIRCLE;
    obj.fill = '';
    return obj;
  }
}
